import styled from 'styled-components';

export const Container = styled.div<{ compact?: boolean }>`
  margin: 0 -12px;
  // RES-999: the 21px top/bottom padding is sized for this block's normal standalone placement.
  // In compact mode (booking-details card), it stacked with the surrounding sections' own margins
  // and read as an oversized gap — 12px matches the card's other section spacing instead.
  padding: ${({ compact }) => (compact ? '12px' : '21px')} 12px;
`;

export const Title = styled.div`
  font: 700 20px/24px ${({ theme }) => theme.fonts.join()};
  color: ${({ theme }) => theme.colors.fontColor};
  margin-bottom: 10px;
`;

// RES-999: matches the booking-details card's other small grey labels (When/Location/Reserved
// by) instead of this block's normal large bold heading.
export const CompactTitle = styled.div`
  font: 600 13px/1 ${({ theme }) => theme.fonts.join()};
  color: ${({ theme }) => theme.colors.palette.systemGreyDark};
  margin-bottom: 10px;
`;

/*
 * RES-1367: `withLeadIn` is what the 11px was always FOR -- separating the list from the
 * description paragraph above it. There is no paragraph on most resources, and no description
 * container either (see amenities.tsx), so the margin was spending 11px on nothing; and inside a
 * collapsible block the surrounding flex `gap` already separates the two, so adding it there
 * stacked 27px between the heading and the first amenity.
 */
export const ListContainer = styled.div<{ withLeadIn?: boolean }>`
  margin-top: ${({ withLeadIn }) => (withLeadIn ? '11px' : '0')};
  display: flex;
  gap: 14px;
  flex-direction: column;

  /* Normalize IconTextBlock icon/text alignment */
  & > div {
    align-items: center;
  }

  & .text-block-icon {
    width: 1.25em;
    text-align: center;
    flex-shrink: 0;
  }
`;

export const AmenitiesDescription = styled.div<{ isOverflowing: boolean; isExpanded: boolean }>`
  position: relative;
  line-height: 22px;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  ${({ isOverflowing }) => isOverflowing && '-webkit-line-clamp: 2'}
  ${({ isExpanded }) => isExpanded && '-webkit-line-clamp: 4'}
`;

export const ReadMoreContainer = styled.span`
  font: 500 16px/22px ${({ theme }) => theme.fonts.join()};
  border: none;
`;

export const AmenitiesDescriptionContainer = styled.div`
  position: relative;
`;

export const ReadMoreButton = styled.span`
  text-decoration: underline;
  color: ${({ theme }) => theme.colors.secondary};
`;
